import styled from "styled-components";

const StyledProfile = styled.section``;

export default StyledProfile;
